import type { RadioGroupProps, Radioprops } from '@eleo-rh/core-ui'
import { Radio } from '@eleo-rh/core-ui'

interface FilterRadioOption {
  label: string
  value: string | null
}

interface FilterRadioGroupProps {
  value: string | null | undefined
  onChange: (value: string | null) => void
  options: FilterRadioOption[]
  groupProps?: Omit<RadioGroupProps, 'children' | 'onChange' | 'value'>
  radioProps?: Omit<Radioprops, 'children' | 'value'>
  radioStyles?: Radioprops['styles']
}

const defaultRadioStyles = {
  label: {
    fontSize: 10,
    textTransform: 'uppercase' as const,
  },
}

export default function FilterRadioGroup({
  value,
  onChange,
  options,
  groupProps,
  radioProps,
  radioStyles,
}: FilterRadioGroupProps) {
  const mergedRadioStyles =
    typeof radioStyles === 'function'
      ? radioStyles
      : {
          ...defaultRadioStyles,
          ...radioStyles,
          label: {
            ...defaultRadioStyles.label,
            ...(radioStyles?.label ?? {}),
          },
        }

  return (
    <Radio.Group
      onChange={e => onChange(e.target.value)}
      size="small"
      optionType="button"
      buttonStyle="outline"
      value={value ?? null}
      {...groupProps}
    >
      {options.map(option => (
        <Radio key={String(option.value)} value={option.value} styles={mergedRadioStyles} {...radioProps}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  )
}
